interface SimpleBeforeAfterProps {
  before: string;
  after: string;
  beforeAlt: string;
  afterAlt: string;
}

const SimpleBeforeAfter = ({ before, after, beforeAlt, afterAlt }: SimpleBeforeAfterProps) => {
  return (
    <div className="relative w-full h-full animate-fade-in">
      <div className="grid grid-cols-2 gap-0 h-full">
        {/* Before Image */}
        <div className="relative h-full bg-muted/50">
          <img
            src={before}
            alt={beforeAlt}
            className="w-full h-full object-cover"
            loading="lazy"
          />
          {/* Before Badge */}
          <div className="absolute top-2 left-2 sm:top-4 sm:left-4 z-10">
            <span className="inline-flex items-center gap-1 sm:gap-2 px-2 py-1 sm:px-4 sm:py-2 rounded-full bg-gradient-to-r from-muted/95 to-muted/90 backdrop-blur-sm text-foreground font-semibold text-xs sm:text-sm shadow-lg border border-border/50">
              😢 Before
            </span>
          </div>
        </div>

        {/* After Image */}
        <div className="relative h-full bg-muted/50">
          <img
            src={after}
            alt={afterAlt}
            className="w-full h-full object-cover"
            loading="lazy"
          />
          {/* After Badge */}
          <div className="absolute top-2 right-2 sm:top-4 sm:right-4 z-10">
            <span className="inline-flex items-center gap-1 sm:gap-2 px-2 py-1 sm:px-4 sm:py-2 rounded-full bg-gradient-to-r from-primary via-primary/90 to-accent backdrop-blur-sm text-primary-foreground font-semibold text-xs sm:text-sm shadow-lg">
              ✨ After
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleBeforeAfter;
